import gql from "graphql-tag";

export const deleteWorkspace = gql`
  mutation DeleteWorkspace($id: ID!) {
    deleteWorkspace(where: { id: $id }) {
      id
    }
  }
`;
